import React, { useEffect, useState } from "react";
import { fetchUserSummaryWithFilters } from "../../../api/userProfile";

const StatItem = ({ imgSrc, title, value }) => (
  <div
    className="d-flex align-items-center bg-light p-3 rounded-3 w-100 w-sm-45 w-md-30 mx-2"
    style={{ maxWidth: "280px" }}
  >
    <img src={imgSrc} alt={`${title} Icon`} className="me-3 rounded-circle" />
    <div>
      <h6 className="mb-0 fs-6 fw-bold">{title}</h6>
      <p className="mb-0 fw-bold fs-3">{value}</p>
    </div>
  </div>
);

const StatsCard = ({ userId }) => {
  const [stats, setStats] = useState({
    totalPlans: 0,
    totalWorkouts: 0,
    totalCaloriesBurned: 0,
    totalTimeSpent: "0 hours",
  });
  const [filter, setFilter] = useState("week");

  useEffect(() => {
    const getUserSummary = async () => {
      try {
        const response = await fetchUserSummaryWithFilters(userId, filter);
        setStats({
          totalPlans: response.totalPlans || 0,
          totalWorkouts: response.totalWorkouts || 0,
          totalCaloriesBurned: response.totalCaloriesBurned || 0,
          totalTimeSpent: response.totalTimeSpent || "0 hours",
        });
      } catch (error) {
        console.error("Error fetching user summary:", error.message || error);
      }
    };

    if (userId) {
      getUserSummary();
    }
  }, [userId, filter]);

  const handleFilterChange = (e) => {
    setFilter(e.target.value);
  };

  const statItems = [
    {
      imgSrc: "https://via.placeholder.com/50",
      title: "Total Calories Burned",
      value: stats.totalCaloriesBurned,
    },
    {
      imgSrc: "https://via.placeholder.com/50",
      title: "Total Hours Spent",
      value: stats.totalTimeSpent,
    },
    {
      imgSrc: "https://via.placeholder.com/50",
      title: "Total Workouts",
      value: stats.totalWorkouts,
    },
  ];

  return (
    <>
      <div
        className=" d-flex justify-content-end"
        style={{ marginLeft: "auto", width: 160 }}
      >
        <select
          id="filterDropdown"
          className="form-select form-select-sm"
          value={filter}
          onChange={handleFilterChange}
        >
          <option value="week">Last Week</option>
          <option value="month">Last Month</option>
          <option value="year">Last Year</option>
        </select>
      </div>

      <div className="card">
        <div className="card-body d-flex justify-content-between ">
          {statItems.map((stat, index) => (
            <StatItem
              key={index}
              imgSrc={stat.imgSrc}
              title={stat.title}
              value={stat.value}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default StatsCard;
